<button
  ngbTooltip="{{ tooltipText() | translate }}"
  tooltipClass="info-tooltip"
  tabindex="0"
  [attr.id]="buttonId() || null"
  [class]="btnCssClasses()"
  [placement]="placement()"
  [attr.data-test]="dataTest()"
>
  <i class="fas fa-info"></i>
</button>
